<template>
  <div class="volunteer__cards">
    <div class="volunteer__item card card_volunteer">
      <header class="card__main">
        <div class="card__image">
          <img
            src="@/assets/images/volunteers/59a267c3-639f-4bf0-b886-7424387519f5.jpg"
            alt
          />
        </div>
        <div class="card__content">
          <div class="card__author">
            <h2>{{ $t("VOLUNTEERS.1.NAME") }}</h2>
            <small class="card__post">{{ $t("VOLUNTEERS.1.POST") }}</small>
          </div>
          <div class="card__text">{{ $t("VOLUNTEERS.1.TEXT") }}</div>
        </div>
      </header>
      <footer class="card__extra">
        <div class="card__country">
          <img
            src="@/assets/images/volunteers/volunteer_rus_country.svg"
            :alt="$t('VOLUNTEERS.1.COUNTRY')"
          />
          <span>
            <strong>{{ $t("VOLUNTEERS.1.COUNTRY") }}</strong>
          </span>
        </div>
        <div class="card__card-requisites">
          <img
            src="@/assets/images/volunteers/volunteer_sber_logo.svg"
            alt="2202 2005 4281 0336"
          />
          <span>
            <strong>2202 2005 4281 0336</strong>
          </span>
        </div>
      </footer>
    </div>
    <div class="volunteer__item card card_volunteer">
      <header class="card__main">
        <div class="card__image">
          <img
            src="@/assets/images/volunteers/2f3497b5-fd1d-4523-8b0b-7b886630c76c.jpg"
            alt
          />
        </div>
        <div class="card__content">
          <div class="card__author">
            <h2>{{ $t("VOLUNTEERS.2.NAME") }}</h2>
            <small class="card__post">{{ $t("VOLUNTEERS.2.POST") }}</small>
          </div>
          <div class="card__text">{{ $t("VOLUNTEERS.2.TEXT") }}</div>
        </div>
      </header>
      <footer class="card__extra">
        <div class="card__country">
          <img
            src="@/assets/images/volunteers/volunteer_kaz_country.svg"
            :alt="$t('VOLUNTEERS.2.COUNTRY')"
          />
          <span>
            <strong>{{ $t("VOLUNTEERS.2.COUNTRY") }}</strong>
          </span>
        </div>
        <div class="card__card-requisites">
          <img
            src="@/assets/images/volunteers/volunteer_halyk_logo.svg"
            alt="4405 6398 1622 7605"
          />
          <span>
            <strong>4405 6398 1622 7605</strong>
          </span>
        </div>
      </footer>
    </div>
    <div class="volunteer__item card card_volunteer">
      <header class="card__main">
        <div class="card__image">
          <img src="@/assets/images/volunteers/Ok9M0M1MmhM.jpg" alt />
        </div>
        <div class="card__content">
          <div class="card__author">
            <h2>{{ $t("VOLUNTEERS.3.NAME") }}</h2>
            <small class="card__post">{{ $t("VOLUNTEERS.3.POST") }}</small>
          </div>
          <div class="card__text">{{ $t("VOLUNTEERS.3.TEXT") }}</div>
        </div>
      </header>
      <footer class="card__extra">
        <div class="card__country">
          <img
            src="@/assets/images/volunteers/volunteer_uzb_country.svg"
            :alt="$t('VOLUNTEERS.3.COUNTRY')"
          />
          <span>
            <strong>{{ $t("VOLUNTEERS.3.COUNTRY") }}</strong>
          </span>
        </div>
        <div class="card__card-requisites">
          <img
            src="@/assets/images/volunteers/volunteer_milly_logo.svg"
            alt="8600 0201 8607 2422"
          />
          <span>
            <strong>8600 0201 8607 2422</strong>
          </span>
        </div>
      </footer>
    </div>
    <div class="volunteer__item card card_volunteer">
      <header class="card__main">
        <div class="card__image">
          <img
            src="@/assets/images/volunteers/a9f7e353-8f29-4c10-8ae4-5a9da096fa66.jpg"
            alt
          />
        </div>
        <div class="card__content">
          <div class="card__author">
            <h2>{{ $t("VOLUNTEERS.4.NAME") }}</h2>
            <small class="card__post">{{ $t("VOLUNTEERS.4.POST") }}</small>
          </div>
          <div class="card__text">{{ $t("VOLUNTEERS.4.TEXT") }}</div>
        </div>
      </header>
      <footer class="card__extra">
        <div class="card__country">
          <img
            src="@/assets/images/volunteers/volunteer_rus_country.svg"
            :alt="$t('VOLUNTEERS.4.COUNTRY')"
          />
          <span>
            <strong>{{ $t("VOLUNTEERS.4.COUNTRY") }}</strong>
          </span>
        </div>
        <div class="card__card-requisites">
          <img
            src="@/assets/images/volunteers/volunteer_sber_logo.svg"
            alt="5336 6903 7683 4067"
          />
          <span>
            <strong>5336 6903 7683 4067</strong>
          </span>
        </div>
      </footer>
    </div>
    <div class="volunteer__item card card_volunteer">
      <header class="card__main">
        <div class="card__image">
          <img
            src="@/assets/images/volunteers/eac9af91-1a4c-4860-a136-2cf2eb0f1ae7.jpg"
            alt
          />
        </div>
        <div class="card__content">
          <div class="card__author">
            <h2>{{ $t("VOLUNTEERS.5.NAME") }}</h2>
          </div>
          <div class="card__text">{{ $t("VOLUNTEERS.5.TEXT") }}</div>
        </div>
      </header>
      <footer class="card__extra">
        <div class="card__country">
          <img
            src="@/assets/images/volunteers/volunteer_kaz_country.svg"
            :alt="$t('VOLUNTEERS.5.COUNTRY')"
          />
          <span>
            <strong>{{ $t("VOLUNTEERS.5.COUNTRY") }}</strong>
          </span>
        </div>
        <div class="card__card-requisites">
          <img
            src="@/assets/images/volunteers/volunteer_kaspi_logo.svg"
            alt="+7 (778) 530 - 70 - 71"
          />
          <span>
            <strong>+7 (778) 530 - 70 - 71</strong>
          </span>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "PostVolunteer"
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.card.card_volunteer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;

  .card {
    &__content {
      padding: 0 30px;
    }

    &__image {
      position: relative;
      padding: 0 0 100% 0;
      overflow: hidden;

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__likes,
    &__country,
    &__card-requisites {
      display: flex;
      align-items: center;
    }

    &__author {
      margin: 20px 0 0;
    }

    &__likes {
      padding: 5px 15px;
      outline: none;

      img {
        margin: 0 5px 0 0;
      }
    }

    &__text {
      margin: 20px 0;
      line-height: 1.3;
    }

    &__extra {
      width: 100%;
      padding: 0 30px 30px;
    }

    &__country,
    &__card-requisites {
      margin: 0 0 10px;

      span {
        margin: 0 0 0 10px;
      }
    }

    &__button {
      padding: 5px 15px;
    }

    &__additional {
      width: 150px;
      text-align: right;
      line-height: 1.2;
    }
  }
}
</style>
